
import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import styled from 'styled-components';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing,
    getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

const RadioComponent = styled(Radio)<{ checked?: boolean }>`
    color: ${({ checked }) =>
        checked
            ? getColor('lightBlue')
            : getColor('lightBorderColor')};

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;

const StyledFormControlLabel = styled(FormControlLabel)`
    margin-right: 10px;

    & .MuiFormControlLabel-label {
        color: ${getColor('inputTextColor')};
        font-family: ${getFontFamily('atlassian')};
        font-size: ${getFontSize('smaller')};
        letter-spacing: ${getLetterSpacing('small')};
        line-height: ${getLineHeight('small')};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const Wrapper = styled.div`
`;

export const FilterType = ({type}) => {
    const [value, setValue] = React.useState(apiProvider.getEntityUpper());

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectAction = (event.target as HTMLInputElement).value;
        setValue(selectAction);
        type(selectAction)
    };

    return (
        <Wrapper>
            <RadioGroup
                row
                aria-label="selectAction"
                name="selectAction"
                value={value}
                onChange={handleChange}>
                <StyledFormControlLabel
                    value={apiProvider.getEntityUpper()}
                    control={<RadioComponent />}
                    label={apiProvider.getEntityUpper() + 's'} />                    
                <StyledFormControlLabel
                    value="Event"
                    control={<RadioComponent />}
                    label="Events" />
            </RadioGroup>
        </Wrapper>
    );
};
